;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import get from "lodash/get"
import Image from "next/image"
import {
  PROFILE_BASICS,
  PROFILE_BASICS_CREDENTIAL_ABBREVIATIONS,
} from "../../../../lib/constants"
import { getRolesString } from "../../../../lib/provider/getRoles"
import getNameToDisplay from "../../../../lib/provider/getNameToDisplay"
import compact from "lodash/compact"

export default function ProfileScoreCard({ provider, user }) {
  const groupLeaderPicSrc = user.photoUrl

  const profileContent = provider?.profileContent
  const getCredentailString = () => {
    const credentialAbbr = get(
      profileContent,
      `[${PROFILE_BASICS}][${PROFILE_BASICS_CREDENTIAL_ABBREVIATIONS}]`,
      [],
    )

    return compact(credentialAbbr).join(", ")
  }

  // when user is me this works. when provider is from the public endpoint this works
  const nameToDisplay = getNameToDisplay({ provider, user })
  const renderProfilePic = () => {
    return (
      <div
        className={
          "flex justify-center absolute w-full top-[-106px] min-[600px]: min-[1100px]:top-[0px] min-[1100px]:w-auto min-[1100px]:left-[-73px]"
        }
      >
        <div
          className={
            "w-[160px] h-[160px] border-solid border-[5px] border-black rounded-[100%] box-border z-10 relative min-[600px]:hidden"
          }
        >
          {groupLeaderPicSrc ? (
            <Image
              priority={true}
              alt="group leader profile picture mobile screen"
              src={groupLeaderPicSrc}
              width={150}
              height={150}
            />
          ) : null}
        </div>
        <div
          className={
            "hidden min-[600px]:block min-[1100px]:hidden w-[178px] h-[178px] border-solid border-[5px] border-black rounded-[100%] box-border z-10 relative"
          }
        >
          {groupLeaderPicSrc ? (
            <Image
              priority={true}
              alt="group leader profile picture md screen"
              src={groupLeaderPicSrc}
              width={178}
              height={178}
            />
          ) : null}
        </div>
        <div
          className={
            "hidden min-[1100px]:block w-[300px] h-[300px] border-solid border-[5px] border-black rounded-[100%] box-border z-10 relative left-[20px] "
          }
        >
          {groupLeaderPicSrc ? (
            <Image
              priority={true}
              alt="group leader profile picture lg screen"
              src={groupLeaderPicSrc}
              width={290}
              height={290}
            />
          ) : null}
        </div>
      </div>
    )
  }
  const renderYellowScoreCard = () => {
    return (
      <div className={"flex justify-center items-center w-full"}>
        <div
          className={
            "bg-[#E6FF63] rounded-[20px] pt-[60px] px-[20px] pb-[30px] min-[600px]:pt-[90px]  min-[1100px]:pt-[40px]  min-[1100px]:pr-[60px] min-[1100px]:pl-[270px] max-w-[1022px] w-full"
          }
        >
          <h1
            className={
              "font-bebas text-[28px] min-[800px]:text-[36px] tracking-[0.1575rem] m-0 leading-[33px] min-[800px]:leading-[43px]"
            }
          >
            {nameToDisplay}
          </h1>
          <div className={"italic  leading-[30px]"}>{getCredentailString()}</div>
          <div className={"mt-[20px] leading-[24px]"}>
            {getRolesString({ provider })}
          </div>
        </div>
      </div>
    )
  }
  return (
    <div
      className={
        "text-black text-center font-roboto tracking-[1.75px] text-[20px] min-[800px]:text-[25px] flex justify-center mt-[150px]  mb-[10px] min-[800px]:mb-[20px] min-[1100px]:h-[300px] min-[1100px]:mt-[80px]"
      }
    >
      <div
        className={
          "flex flex-col min-[1100px]:flex-row-reverse max-w-[1054px] mx-[15px] relative min-[600px]:mx-[24px]"
        }
      >
        {renderYellowScoreCard()}
        {renderProfilePic()}
      </div>
    </div>
  )
}
